/**
 * Detects vue-router's pagehide scroll snapshot passed to history.replaceState.
 * Shape: existing history.state fields plus a `scroll` position object.
 */
export function isVueRouterHistoryScrollSnapshot(state: unknown): boolean {
  if (state === null || typeof state !== 'object') {
    return false;
  }

  const record = state as Record<string, unknown>;

  return (
    'scroll' in record &&
    ('current' in record || 'position' in record || 'back' in record)
  );
}
